import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, orderBy } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { MatrizTarifaDistanciaEdit } from "./edit";
import { mapPrevious } from "keautils";
const EditModal = MatrizTarifaDistanciaEdit;

export interface MatrizTarifaDistanciaDTO extends models.MatrizTarifaDistancia {
    DistanciaDesde?: number;
}
type Entity = MatrizTarifaDistanciaDTO;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Distancia desde (km)", cell: x => ({ data: x.DistanciaDesde }) },
        { title: "Distancia hasta (km)", cell: x => ({ data: x.DistanciaHasta }) },
        { title: "Tarifa por sobre", cell: x => ({ data: kea.formatCurrency(x.TarifaSobre) }) },
        { title: "Tarifa por kilo excedente", cell: x => ({ data: kea.formatCurrency(x.TarifaPorExcedenteKilos) }) },
        { title: "Tarifa por m3", cell: x => ({ data: kea.formatCurrency(x.ValorMetroCubicoCuandoExceda) }) },
    ];
}

/**
* Listado de MatrizTarifaDistancia
*/
class MatrizTarifaDistanciaListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            await this.props.onChange(orderBy([...oldList, newItem], x => x.DistanciaHasta));
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            await this.props.onChange(orderBy(oldList.map(x => x == item ? newItem : x), x => x.DistanciaHasta));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.DistanciaHasta + " km");
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Distancias</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda={true} />
                {this.modals.component}
            </div>
        );
    }
}

function mapValue(value: models.MatrizTarifaDistancia[] | undefined): Entity[] {
    if (!value) return [];

    return mapPrevious(value, (prev, curr) => ({ ...curr, DistanciaDesde: prev.DistanciaHasta } as Entity), { DistanciaHasta: 0 });
}
export const MatrizTarifaDistanciaList = componentToRx(kea.mapProps(MatrizTarifaDistanciaListNoRx, x => ({ ...x, value: mapValue(x.value) })));


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/componentes/distancias/list.tsx